import React from 'react';
import { CustomCellRendererProps } from 'ag-grid-react';
import { ORCHESTRATION_STATUSES } from '../../dashboardContants';
import { ServerDashboardJob } from '../../dashboardType';

const StepCell = (properties: CustomCellRendererProps<ServerDashboardJob>) => {
  const {
    IN_PROGRESS,
    FAILED,
    STOPPED,
    STOPPING,
    FINISHED,
    FINISHED_ERROR,
    PENDING,
  } = ORCHESTRATION_STATUSES;
  const steps = properties.data?.steps?.length || 1;
  const stepsCount = properties.data?.stepsCount;
  const status = properties.data?.status;
  if (status === IN_PROGRESS) {
    return <span>{`Step ${steps} of ${stepsCount}`}</span>;
  }
  if (status === PENDING) {
    return <span>Pending</span>;
  }
  if (status === FAILED) {
    return <span>Failed</span>;
  }
  if (status === STOPPED) {
    return <span>Stopped</span>;
  }
  if (status === STOPPING) {
    return <span>Stopping</span>;
  }
  if (status === FINISHED) {
    return <span>Finished</span>;
  }
  if (status === FINISHED_ERROR) {
    return <span>Finished</span>;
  }

  return null;
};

export default StepCell;
